export enum ObjectMarkKinds {
  Error = 1,
  Warning = 2,
}
